"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HardwareStatusT = exports.HardwareStatus = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const log_data_js_1 = require("../../../solarxr-protocol/datatypes/log-data.js");
/**
 * Mostly-dynamic status info about a tracked device's firmware
 */
class HardwareStatus {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsHardwareStatus(bb, obj) {
        return (obj || new HardwareStatus()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsHardwareStatus(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new HardwareStatus()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    errorStatus() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : null;
    }
    ping() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : null;
    }
    /**
     * “Received Signal Strength Indicator" between device and wifi adapter in dBm
     */
    rssi() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readInt16(this.bb_pos + offset) : null;
    }
    /**
     * Temperature in degrees celsius
     */
    mcuTemp() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    batteryVoltage() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    batteryPctEstimate() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : null;
    }
    logData(obj) {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? (obj || new log_data_js_1.LogData()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startHardwareStatus(builder) {
        builder.startObject(8);
    }
    static addErrorStatus(builder, errorStatus) {
        builder.addFieldInt8(0, errorStatus, 0);
    }
    static addPing(builder, ping) {
        builder.addFieldInt16(2, ping, 0);
    }
    static addRssi(builder, rssi) {
        builder.addFieldInt16(3, rssi, 0);
    }
    static addMcuTemp(builder, mcuTemp) {
        builder.addFieldFloat32(4, mcuTemp, 0);
    }
    static addBatteryVoltage(builder, batteryVoltage) {
        builder.addFieldFloat32(5, batteryVoltage, 0);
    }
    static addBatteryPctEstimate(builder, batteryPctEstimate) {
        builder.addFieldInt8(6, batteryPctEstimate, 0);
    }
    static addLogData(builder, logDataOffset) {
        builder.addFieldOffset(7, logDataOffset, 0);
    }
    static endHardwareStatus(builder) {
        const offset = builder.endObject();
        return offset;
    }
    unpack() {
        return new HardwareStatusT(this.errorStatus(), this.ping(), this.rssi(), this.mcuTemp(), this.batteryVoltage(), this.batteryPctEstimate(), (this.logData() !== null ? this.logData().unpack() : null));
    }
    unpackTo(_o) {
        _o.errorStatus = this.errorStatus();
        _o.ping = this.ping();
        _o.rssi = this.rssi();
        _o.mcuTemp = this.mcuTemp();
        _o.batteryVoltage = this.batteryVoltage();
        _o.batteryPctEstimate = this.batteryPctEstimate();
        _o.logData = (this.logData() !== null ? this.logData().unpack() : null);
    }
}
exports.HardwareStatus = HardwareStatus;
class HardwareStatusT {
    constructor(errorStatus = null, ping = null, rssi = null, mcuTemp = null, batteryVoltage = null, batteryPctEstimate = null, logData = null) {
        this.errorStatus = errorStatus;
        this.ping = ping;
        this.rssi = rssi;
        this.mcuTemp = mcuTemp;
        this.batteryVoltage = batteryVoltage;
        this.batteryPctEstimate = batteryPctEstimate;
        this.logData = logData;
    }
    pack(builder) {
        const logData = (this.logData !== null ? this.logData.pack(builder) : 0);
        HardwareStatus.startHardwareStatus(builder);
        if (this.errorStatus !== null)
            HardwareStatus.addErrorStatus(builder, this.errorStatus);
        if (this.ping !== null)
            HardwareStatus.addPing(builder, this.ping);
        if (this.rssi !== null)
            HardwareStatus.addRssi(builder, this.rssi);
        if (this.mcuTemp !== null)
            HardwareStatus.addMcuTemp(builder, this.mcuTemp);
        if (this.batteryVoltage !== null)
            HardwareStatus.addBatteryVoltage(builder, this.batteryVoltage);
        if (this.batteryPctEstimate !== null)
            HardwareStatus.addBatteryPctEstimate(builder, this.batteryPctEstimate);
        HardwareStatus.addLogData(builder, logData);
        return HardwareStatus.endHardwareStatus(builder);
    }
}
exports.HardwareStatusT = HardwareStatusT;
